var _g, _defs;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgFinanceV2(_ref, svgRef) {
  let title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_50559_25122)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M9.16667 12.5H10.8333C11.2754 12.5 11.6993 12.3244 12.0118 12.0118C12.3244 11.6992 12.5 11.2753 12.5 10.8333C12.5 10.3913 12.3244 9.96734 12.0118 9.65478C11.6993 9.34222 11.2754 9.16663 10.8333 9.16663H8.33333C7.83333 9.16663 7.41667 9.33329 7.16667 9.66663L2.5 14.1666",
    stroke: "white",
    strokeWidth: 1.4,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M5.83203 17.5L7.16536 16.3333C7.41536 16 7.83203 15.8333 8.33203 15.8333H11.6654C12.582 15.8333 13.4154 15.5 13.9987 14.8333L17.832 11.1666C18.1536 10.8628 18.3413 10.4436 18.3538 10.0013C18.3663 9.55902 18.2026 9.12989 17.8987 8.80832C17.5948 8.48674 17.1756 8.29906 16.7333 8.28656C16.2911 8.27405 15.8619 8.43776 15.5404 8.74165L12.0404 11.9916",
    stroke: "white",
    strokeWidth: 1.4,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1.66797 13.3334L6.66797 18.3334",
    stroke: "white",
    strokeWidth: 1.4,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M13.3346 9.91671C14.6693 9.91671 15.7513 8.83473 15.7513 7.50004C15.7513 6.16535 14.6693 5.08337 13.3346 5.08337C11.9999 5.08337 10.918 6.16535 10.918 7.50004C10.918 8.83473 11.9999 9.91671 13.3346 9.91671Z",
    stroke: "white",
    strokeWidth: 1.4,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M5 6.66663C6.38071 6.66663 7.5 5.54734 7.5 4.16663C7.5 2.78591 6.38071 1.66663 5 1.66663C3.61929 1.66663 2.5 2.78591 2.5 4.16663C2.5 5.54734 3.61929 6.66663 5 6.66663Z",
    stroke: "white",
    strokeWidth: 1.4,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_50559_25122"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 20,
    height: 20,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgFinanceV2);
export default __webpack_public_path__ + "static/media/financeV2.3cf0ce093d540eb34d987b2c9c40f493.svg";
export { ForwardRef as ReactComponent };